import RealtimeServiceSignalR from "./RealtimeServiceSignalR";

class RealtimeServiceFactory {
  static getInstance() {
    return new RealtimeServiceSignalR();
  }
}

export default RealtimeServiceFactory;
